import get from 'lodash/get';
import React from 'react';
import { Copy } from '../copy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const replaceInterpolatedVariables = (data: any, copy: Copy): Copy => {
  // This regex captures variables within {{ }}
  const regex = /{{[\w.-]+}}/gi;

  return Object.entries(copy).reduce((acc, [key, value]) => {
    // We don't expect to have falsy values, but just in case,
    // we can leave them untouched.
    // Leave React components as they are if their are any present in the variant.
    if (!value || React.isValidElement(value)) {
      return acc;
    }

    // Copy can have nested objects, and we want to replace
    // all strings, even deep in the object.
    if (typeof value === 'object') {
      return {
        ...acc,
        [key]: replaceInterpolatedVariables(data, value)
      };
    }

    const matches = 'number' !== typeof value ? value.match(regex) : undefined;
    if (Array.isArray(matches)) {
      matches.forEach((match) => {
        // Extract the variable name from the squigglies.
        const capturedVariableName = match.slice(2, -2);

        const populatedField = get(data, capturedVariableName) || '';

        value = value.replace(match, populatedField);
      });
    }

    return {
      ...acc,
      [key]: value
    };
  }, copy);
};
